export default __webpack_public_path__ + "static/media/cloud-management-services.f1f3cfe6.png";